document.addEventListener("click", function(e) {
  if (e.target.classList.contains("accordion-title")) {

    const accordion = e.target.closest(".custom-accordion");
    const item = e.target.closest(".accordion-item");

    if (!accordion || !item) return;

    accordion.querySelectorAll(".accordion-item").forEach(el => {
      if (el !== item) el.classList.remove("active");
    });

    item.classList.toggle("active");
  }
});